import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Card from '../../../../../1stlog-ui/src/components/Card'
import IncoTerms2020 from '../../components/IncoTerms2020'

const CustomsTerms = (props) => {
  const { customsTerms } = props

  return (
    <Card title={i18n.t('order_incoterms', 'Frankatur - Incoterms 2020')}>
      <IncoTerms2020 isReadonly value={customsTerms} />
    </Card>
  )
}

export default CustomsTerms
